import TokenManager from '@viome/viome-base/src/api/TokenManager';
import { Loader } from '@design-system/Loader';
import { useState } from 'react';
import environment from '@config/environment.ts';
import { useCancerDetectUser } from '@hooks/useCancerDetectUser';

export const CancerDetectPage = () => {
  const { isCancerDetectClicked } = useCancerDetectUser();
  const userType = 'non_fbi_user';
  const [span] = useState(() => Date.now().valueOf());
  const OLD_CANCER_DETECT_PAGE_URL = `${environment.OLD_BASE_URL}/?in_iframe=true&span=${span}&cancer_detect_ui=${isCancerDetectClicked}&user_type=${userType}&token=${TokenManager.getAuthToken()}`;
  const IFRAME_HEIGHT = '100%';
  const IFRAME_WIDTH = '100%';
  const [iframeLoading, setIframeLoading] = useState(true);
  
  return (
    <div>
      {iframeLoading && (
        <Loader />
      )}
      <iframe
        src={OLD_CANCER_DETECT_PAGE_URL}
        height={IFRAME_HEIGHT}
        width={IFRAME_WIDTH}
        style={{ height: '100vh' }}
        frameBorder="0"
        allowFullScreen
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
};